export default __webpack_public_path__ + "static/media/num-icon1.dd6c496f.svg";